import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

import { MUserCard } from '../molecules';

export default function OUserlist({ className, items }) {
	return (
		<article className={`o-user-list ${className}`}>
			<h2>
				<FormattedMessage id="ABOUT_US.WHO_ARE_WE" defaultMessage="" />
			</h2>
			<div className="users-wrapper">
				{items.map(item => (
					<MUserCard
						key={item.name}
						img={item.img}
						email={item.email}
						name={item.name}
					/>
				))}
			</div>
		</article>
	);
}

OUserlist.propTypes = {
	className: PropTypes.string,
	items: PropTypes.array.isRequired,
};

OUserlist.defaultProps = {
	className: '',
};




// WEBPACK FOOTER //
// ./src/components/organisme/_organisme.user-list.js